<div>
  <div class="container-fluid p-0 m-0">
      <div class="row p-0 m-0 mb-4">
          <div class="col mr-auto ml-auto">
              <h2 class="text-center">{{'lockersize.title'|traduccion}}</h2>
          </div>
      </div>
      <div class="row p-0 m-0">
          <div class="col mr-auto ml-auto d-flex justify-content-center">
            <app-offer-locker [lockers]="sizes" [prices]="prices" [mode]="mode" (callBack)="callBack($event)"></app-offer-locker>
          </div>
      </div>
  </div>
</div>